import styles from './Typography.module.css';

type Typographies =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'subheading'
  | 'body'
  | 'body-small'
  | 'bold'
  | 'label'
  | 'label-secondary'
  | 'link'
  | 'subtle'
  | 'warning';

interface TypographyProps {
  children: React.ReactNode;
  sizes?: Typographies[];
  inherit?: boolean;
}

export function Typography({ sizes = ['body'], inherit = false, children }: TypographyProps) {
  return (
    <span
      className={sizes.map((size) => [styles[size]]).join(' ')}
      style={{ lineHeight: inherit ? 'inherit' : undefined }}
    >
      {children}
    </span>
  );
}
